import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function TrackLocation({ children }) {
  const location = useLocation();

  useEffect(() => {
    localStorage.setItem("lastRoute", location.pathname);
  }, [location]);

  return children;
}
